module.exports = "/static/assets/919f80062b14819e7e89e9dbf77e16db.png";